import { Directive, Input, forwardRef, OnInit } from '@angular/core';
import { NG_VALIDATORS, Validator, Validators, ValidatorFn, AbstractControl } from '@angular/forms';

import { PasswordValidators } from './password-validators';


export class PasswordValidatorDirective implements Validator, OnInit {
     repeatCharacter: number = 4;
     alphabeticalCharacter: number = 1;
     digitCharacter: number = 1;
     lowercaseCharacter: number = 1;
     uppercaseCharacter: number = 1;

    private repeatCharacterValidator: ValidatorFn;
    private alphabeticalCharacterValidator: ValidatorFn;
    private digitCharacterValidator: ValidatorFn;
    private lowercaseCharacterValidator: ValidatorFn;
    private uppercaseCharacterValidator: ValidatorFn;

    ngOnInit() {
        this.repeatCharacterValidator = PasswordValidators.repeatCharacterRegexRule(this.repeatCharacter);
        this.alphabeticalCharacterValidator = PasswordValidators.alphabeticalCharacterRule(this.alphabeticalCharacter);
        this.digitCharacterValidator = PasswordValidators.digitCharacterRule(this.digitCharacter);
        this.lowercaseCharacterValidator = PasswordValidators.lowercaseCharacterRule(this.lowercaseCharacter);
        this.uppercaseCharacterValidator = PasswordValidators.uppercaseCharacterRule(this.uppercaseCharacter);

    }

    validate(c: AbstractControl): { [key: string]: any } {
        let compose: ValidatorFn = Validators.compose([this.repeatCharacterValidator,
        this.digitCharacterValidator, this.alphabeticalCharacterValidator,
        this.lowercaseCharacterValidator, this.uppercaseCharacterValidator]);
        return compose(c);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[password][formControlName],[password][formControl],[password][ngModel]',
    providers: [{
        provide: NG_VALIDATORS,
        // tslint:disable-next-line:no-forward-ref
        useExisting: forwardRef(() => PasswordValidatorDirective),
        multi: true
    }]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'repeatCharacter': [{ type: Input },],
'alphabeticalCharacter': [{ type: Input },],
'digitCharacter': [{ type: Input },],
'lowercaseCharacter': [{ type: Input },],
'uppercaseCharacter': [{ type: Input },],
};
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
